module.exports = __webpack_public_path__ + "static/img/bonusBg.c43d8ba7.png";